import { z } from "zod";

import { defineEvents } from "~/analytics/factory";

export const events = defineEvents("advertising.campaign-edit", {
  saved: z.object({
    campaign_id: z.string(),
    account_id: z.string(),
    campaign_type: z.string(),
  }),
  discarded: z.object({
    campaign_id: z.string(),
    account_id: z.string(),
    label: z.string().optional(),
  }),
});

export type Events = typeof events;
